import { Check, X } from "lucide-react";
import { cn } from "@/lib/utils";

interface PasswordRequirementsProps {
  password: string;
  className?: string;
}

export function PasswordRequirements({ password, className }: PasswordRequirementsProps) {
  const requirements = [
    { label: "Mínimo 12 caracteres", test: (pwd: string) => pwd.length >= 12 },
    { label: "Uma letra maiúscula", test: (pwd: string) => /[A-Z]/.test(pwd) },
    { label: "Uma letra minúscula", test: (pwd: string) => /[a-z]/.test(pwd) },
    { label: "Um número", test: (pwd: string) => /[0-9]/.test(pwd) },
    { label: "Um caractere especial", test: (pwd: string) => /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(pwd) },
  ];

  return (
    <div className={cn("space-y-2", className)}>
      <p className="text-sm font-medium text-muted-foreground">Requisitos da senha:</p>
      <div className="space-y-1">
        {requirements.map((req, idx) => {
          const isValid = password ? req.test(password) : false;
          return (
            <div key={idx} className="flex items-center gap-2 text-sm">
              {isValid ? (
                <Check className="h-4 w-4 text-success flex-shrink-0" />
              ) : (
                <X className="h-4 w-4 text-muted-foreground flex-shrink-0" />
              )}
              <span className={cn(
                "transition-colors",
                isValid ? "text-success" : "text-muted-foreground"
              )}>
                {req.label}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
